import * as echarts from 'echarts';

export const buildPieChart = (el, data) => {
  console.log(data);
  echarts.dispose(el);
  const chart = echarts.init(el);
  const option = {
    color: ['#5aff00', '#ff0000'],
    series: [
      {
        type: 'pie',
        radius: ['40%', '70%'],
        data: data,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
      {
        type: 'pie',
        radius: ['40%', '70%'],
        data: data,
        label: {
          position: 'inside',
          formatter: '{d}%',
          fontSize: 14,
        },
      },
    ],
  };
  chart.setOption(option);
  return chart;
};
